const empty = () => ({ em_montagem: 0, pendentes: 0, lancados: 0 });
export default {
  namespaced: true,
  state: { contexto: null, requisicao: 0, contador: empty() },
  mutations: {
    RESET(state, contexto) { state.contexto = contexto; state.contador = empty(); },
    INICIAR(state) { state.requisicao++; },
    SET(state, { contexto, requisicao, contador }) {
      if (state.contexto === contexto && state.requisicao === requisicao) state.contador = contador;
    }
  },
  actions: {
    async atualizar({ state, commit, rootState, rootGetters }, http) {
      const empresa = rootState.empresas.find(e => e.isDefault);
      const contexto = empresa?.x_auth && rootGetters['configs/leiaAtiva'] ? `${empresa.connectionId}:${empresa.x_auth}` : null;
      if (state.contexto !== contexto) commit('RESET', contexto);
      commit('INICIAR');
      const requisicao = state.requisicao;
      if (!contexto) return;
      const response = await http.get('v2/chatbot/pedidos/contador', {
        headers: { 'x-lecard-key': empresa.x_auth }
      });
      commit('SET', { contexto, requisicao, contador: response.data });
    }
  }
};
